import { useState } from 'react';
import { supabase } from '../config/supabase';
import toast from 'react-hot-toast';

export const useAdminCourses = () => {
  const [loading, setLoading] = useState(false);

  const createCourse = async (courseData) => {
    setLoading(true);
    try {
      const { data, error } = await supabase
        .from('courses')
        .insert([courseData])
        .select()
        .single();

      if (error) throw error;

      toast.success('Course created successfully');
      return { data, error: null };
    } catch (error) {
      console.error('Error creating course:', error);
      toast.error('Failed to create course');
      return { data: null, error };
    } finally {
      setLoading(false);
    }
  };

  const updateCourse = async (courseId, updates) => {
    setLoading(true);
    try {
      const { data, error } = await supabase
        .from('courses')
        .update(updates)
        .eq('id', courseId)
        .select()
        .single();

      if (error) throw error;

      toast.success('Course updated successfully');
      return { data, error: null };
    } catch (error) {
      console.error('Error updating course:', error);
      toast.error('Failed to update course');
      return { data: null, error };
    } finally {
      setLoading(false);
    }
  };

  const deleteCourse = async (courseId) => {
    setLoading(true);
    try {
      const { error } = await supabase
        .from('courses')
        .delete()
        .eq('id', courseId);

      if (error) throw error;

      toast.success('Course deleted successfully');
      return { error: null };
    } catch (error) {
      console.error('Error deleting course:', error);
      toast.error('Failed to delete course');
      return { error };
    } finally {
      setLoading(false);
    }
  };

  const togglePublishStatus = async (courseId, publishStatus) => {
    try {
      const { error } = await supabase
        .from('courses')
        .update({ is_published: publishStatus })
        .eq('id', courseId);

      if (error) throw error;

      toast.success(`Course ${publishStatus ? 'published' : 'unpublished'} successfully`);
      return { error: null };
    } catch (error) {
      console.error('Error toggling publish status:', error);
      toast.error('Failed to update publish status');
      return { error };
    }
  };

  return {
    createCourse,
    updateCourse,
    deleteCourse,
    togglePublishStatus,
    loading
  };
};